var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84446 1.15554C10.4685 1.77959 10.4685 2.79138 9.84446 3.41544L3.94272 9.31717C3.68673 9.57317 3.36597 9.75478 3.01475 9.84258L1.18425 10.3002C0.891669 10.3734 0.626646 10.1083 0.699792 9.81575L1.15742 7.98525C1.24522 7.63403 1.42683 7.31327 1.68283 7.05728L7.58456 1.15554C8.20862 0.531487 9.22041 0.531487 9.84446 1.15554ZM7.01953 2.85038L2.2478 7.62225C2.0942 7.77585 1.98524 7.9683 1.93255 8.17904L1.63642 9.36358L2.82096 9.06745C3.0317 9.01476 3.22415 8.9058 3.37775 8.7522L8.14931 3.98015L7.01953 2.85038ZM8.14954 1.72051L7.58442 2.28549L8.71419 3.41527L9.27948 2.85046C9.59151 2.53844 9.59151 2.03254 9.27948 1.72051C8.96746 1.40849 8.46156 1.40849 8.14954 1.72051Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.dc24b67cfb115d708eb0aa19e6240ce1.svg";
export { ForwardRef as ReactComponent };